// Cliente de /v1/images/quitar-fondo: el recorte con alpha de una capa de imagen del
// Estudio de Video (BiRefNet v2 con Bria de respaldo, en el backend). Gratis: no
// pasa por créditos (ADR-2026-09-27-quitar-fondo-en-el-estudio-birefnet).
//
// Devuelve la URL FIRMADA del PNG en nuestro Storage (vence a la hora): quien llama
// lo baja y lo da de alta como asset del proyecto por `uploadProjectAsset`, que es el
// único camino de escritura de `video_project_assets`.

import { atlasBackendFetch } from './atlasBackend';

export async function postQuitarFondo(origen: {
  bucket: string;
  path: string;
}): Promise<{ url: string; proveedor: string }> {
  const res = await atlasBackendFetch('/v1/images/quitar-fondo', {
    image_bucket: origen.bucket,
    image_path: origen.path,
  });
  const body = (await res.json().catch(() => null)) as
    | { url?: string; proveedor?: string; error?: string }
    | null;
  if (!res.ok || !body?.url) {
    throw new Error(body?.error || 'No se pudo quitar el fondo. Probá de nuevo en un momento.');
  }
  return { url: body.url, proveedor: body.proveedor ?? 'birefnet' };
}
